import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import Popup from 'reactjs-popup'
import WOW from "wowjs";
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
//import {baseUrlMap} from '../../Comman/apiEndPoints'
import { checkPermission} from '../../auth';

class DashboardComponent extends Component {
    constructor(props) {
        super(props);
     
    }

    componentDidMount() {
        const wow = new WOW.WOW();
        wow.init();
    } 

    // openMapApplication = () => { 
    //     var href = baseUrlMap + "#/authentication/Login";
    //     var ID =  sessionStorage.getItem('SuperAdminUserID')
    //     const newWindow = window.open(href+ '?UserId='+ID, '_blank', 'noopener,noreferrer')
    //       if (newWindow) newWindow.opener = null 
    //   }

    render() {
        const { t } = this.props;
        let { superMapUser } = false;
        var userId = sessionStorage.getItem('SuperAdminUserID') ;
        if(userId == 15)
        {
            superMapUser = true;
        }
        if(superMapUser){
        return (
            <div className="social grid">
                    
                    <div className="grid-info"> 
                        {/* <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="3000ms;">
                            <div className="comments tweets box3" style={{cursor: 'pointer'}}>
                             <a onClick={()=>this.openMapApplication()} target="_blank" > 
                                
                            <div className="comments-icon">
                                <i class="fa fa-map-marker" aria-hidden="true"></i>
                                </div>
                                <div className="comments-info likes-info">
                                <h3>{t('Dashboard.MAP')}</h3>

                                </div>
                                 </a>
                                <div className="clearfix"> </div>
                            </div> 
                        </div>    */}
                    </div>
                    
            </div>
        )
        }
        else{
            return (
                <div className="social grid">
                        <div className="grid-info">
                           
                          { checkPermission('First_Responders_List') &&  <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="1000ms;">
                                <div className="comments tweets box3">
                                    <Link className="nav-link" to="/superadmin/FirstResponder">
                                        <div className="comments-icon">
                                            
                                            <i className="fas fa-running" aria-hidden="true"></i>
                                        </div>
                                        <div className="comments-info tweets-info">
                                            <h3>{t('Dashboard.FIRST RESPONDER')}</h3>
    
                                        </div>
                                    </Link>   
                                    <div className="clearfix"> </div>
                                </div>
                            </div>}
                            
                            { checkPermission('Terms_And_Conditions_Setting') && <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="1000ms;">
                                <div className="comments views box4">
                                    <Link className="nav-link" to="/superadmin/terms-of-use-setting">
                                        <div className="comments-icon">
                                            <i className="fa fa-cog" aria-hidden="true"></i>
                                        </div>
                                        <div className="comments-info views-info">
                                            <h3>{t('Dashboard.SETTING')}</h3>
    
                                        </div>
                                    </Link>    
                                    <div className="clearfix"> </div>
                                </div>
                            </div>}
                           { checkPermission('Alarm_Rules') &&  <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="3000ms;">
                                <div className="comments tweets box3">
                                <Link className="nav-link" to="/superadmin/alarm-rules">
                                    <div className="comments-icon">
                                        <i className="fa fa-music" aria-hidden="true"></i>
                                    </div>
                                    <div className="comments-info likes-info">
                                        <h3>{t('Dashboard.ALARM SETTING')}</h3>
    
                                    </div>
                                    </Link>
                                    <div className="clearfix"> </div>
                                </div>
                            </div>}
                            <div className="clearfix"> </div>
                        </div>
                        <div className="grid-info">
                           { checkPermission('Add_New_Notification') && <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="3000ms;">
                                <div className="comments tweets box3">
                                <Link className="nav-link" to="/superadmin/addNotification">
                                    <div className="comments-icon">
                                        <i className="fa fa-bell-o" aria-hidden="true"></i>
                                    </div>
                                    <div className="comments-info likes-info">
                                        <h3>{t('Dashboard.NOTIFICATION SETTING')}</h3>
    
                                    </div>
                                    </Link>
                                    <div className="clearfix"> </div>
                                </div>
                            </div>  }
    
                            { checkPermission('Add_Feedback_Question_Details') && <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="3000ms;">
                                <div className="comments likes box5">
                                <Link className="nav-link" to="/superadmin/feedback-setting">
                                    <div className="comments-icon">
                                        <i className="fa fa-comments-o" aria-hidden="true"></i>
                                    </div>
                                    <div className="comments-info likes-info">
                                        <h3>{t('Dashboard.FEEDBACK SETTING')}</h3>
    
                                    </div>
                                    </Link>
                                    <div className="clearfix"> </div>
                                </div>
                            </div>}
                            {/* <div className="col-md-3 top-comment-grid wow zoomIn" data-wow-duration="3000ms;">
                                <div className="comments tweets box3" style={{cursor: 'pointer'}}>
                                 <a  className="nav-link"  onClick={()=>this.openMapApplication()} target="_blank" > 
                                    <div className="comments-icon">
                                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                                    </div>
                                    <div className="comments-info likes-info">
                                    <h3>{t('Dashboard.MAP')}</h3>
    
                                    </div>
                                </a> 
                                    <div className="clearfix"> </div>
                                </div>
                            </div>    */}
                        </div>
                        
                </div>
            )
        }
    }
}

export default withNamespaces()(withRouter(DashboardComponent));

